module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/bg_note_w-47e968e1db1135bb64cf40fac73a2821.png";